<template>
  <div style="width:100%">
    <Header :title="$t('m.ForgetPass')"></Header>
    <div class="banner">
      <div class="stylebanner"></div>
    </div>
    <div class="form">
      <div class="formitem">
        <input autocomplete='off' :placeholder="$t('m.PlsEnterCheckEmail')" style="border:none;outline:none" v-model="value">
        <span @click="value=''" class="icon" v-if="value"><Icon class="color" type="ios-close-circle"></Icon></span>
      </div>
      <div :class="{bgc:(value),button:true}" @click="sub">{{$t('m.Send')}}</div>
    </div>
    <div class="logo">
      <div class="stylebanner2"></div>
    </div>
    <div class="modelwrap" v-if="model">
      <div class="model">
        <div class="modeltitle">{{$t('m.EmailSendOK')}}</div>
        <div @click="sure" class="modelact color">OK</div>
      </div>
    </div>
  </div>
</template>
<script>
 var lang = localStorage.getItem('locale');
 console.log(lang);
 if(lang=='en-US'){
 document.title="标题";
 }else
 {
   document.title="title";
 }
</script>
<script>
  import Header from '../header/header'
  import {forgetpass} from '../../assets/js/url'

  export default {
    name: "forgetpassword",
    data() {
      return {
        value: "",
        model: false
      }
    },
    components: {
      Header
    },
    methods: {
      sub() {
        const reg2 = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
        if (reg2.test(this.value)) {
          this.$http.post(forgetpass, {email: this.value}).then(
            res => {
              if (res.data.status == 2000) {
                this.model = true
              } else {
                this.$toast(res.data.data.errorDes);
              }
            },
            err => {
            }
          )
        } else {
          this.$toast(this.$t('m.PlsEnterRightEmail'));
        }
      },
      sure() {
        this.model = false;
        this.$router.push({path: "/resetpassword2"})
      }
    }
  }
</script>
<style scoped>
  .banner {
    margin-top: 0.3rem;
    width: 100%;
    height: 0.48rem;
    text-align: center;
  }

  .banner img {
    width: 2.3rem;
  }

  .form {
    margin: 0.30rem 0.30rem 0.20rem;
    height: 1.50rem;
    position: relative;
  }

  .hide {
    width: 0;
    height: 0;
    position: absolute;
    opacity: 0;
    top: -200px;
    left: 0;
  }

  .formitem {
    width: 100%;
    height: 0.5rem;
    background-color: #f6f7fa;
    border-radius: 3px;
    margin-top: 6px;
    box-sizing: border-box;
    padding: 0 0.15rem;
  }

  .formitem input {
    height: 0.5rem;
    width: 2.5rem;
    background-color: transparent;
    border: none;
    outline: none;
  }

  .formitem input:visited {
    border: none;
  }

  .formitem input:focus {
    border: none;
  }

  .formitem input:active {
    border: none;
  }

  .button {
    width: 100%;
    height: 0.44rem;
    background-color: #BEC9BC;
    border-radius: 3px;
    margin-top: 0.2rem;
    box-sizing: border-box;
    padding: 0 0.15rem;
    text-align: center;
    line-height: 0.44rem;
    font-size: 0.16rem;
    color: #fff;
  }

  .logo {
    margin-top: 1rem;
    width: 100%;
    height: 0.26rem;
    text-align: center;
  }

  .logo img {
    width: 1.01rem;
    height: 0.26rem;
  }

  i {
    font-size: 0.2rem;
    vertical-align: middle;
  }

  .icon {
    height: 0.5rem;
    line-height: 0.5rem;
    float: right;
  }

  .modelwrap {
    width: 100%;
    height: 100%;
    top: 0.44rem;
    left: 0px;
    position: fixed;
    background: rgba(0, 0, 0, .4)
  }

  .model {
    position: absolute;
    top: 40%;
    left: 50%;
    margin-top: -0.54rem;
    margin-left: -1.35rem;
    width: 2.70rem;
    min-height: 1.08rem;
    background-color: #fff;
    border-radius: 0.12rem;
    box-sizing: border-box;
    padding: 0.20rem 0.06rem;
  }

  .modeltitle {
    text-align: center;
    min-height: 0.34rem;
    line-height: 0.34rem;
    font-size: 0.17rem;
    color: #000;
  }

  .modelact {
    text-align: center;
    height: 0.34rem;
    line-height: 0.34rem;
    font-size: 0.17rem;
    color: #000;
  }
</style>




// WEBPACK FOOTER //
// src/components/login/forgetpassword.vue